// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.CustomTable_dashboard__t39AK {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.CustomTable_dashboardContain__VKEgM {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_dashboardContain__VKEgM,
.CustomTable_bodythemedark__4wTbd .CustomTable_dashboard__t39AK,
.CustomTable_bodythemedark__4wTbd .CustomTable_cont2__lnfXt {
  background-Color: #0f1824;
}

.CustomTable_top_header__WYT4x .CustomTable_top_header_inner__9fMtV {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.CustomTable_cont2__lnfXt {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.CustomTable_subLink__8x57G svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.CustomTable_cst_vendr__JonZi input {
  min-height: 35px !important;
}

.CustomTable_cst_vendr__JonZi .CustomTable_form-control__xBV9j {
  background-color: #f5f6fa;
  border: none;
}

.CustomTable_footer__6d2-Q {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.CustomTable_bodythemelight__3QZuf {
  background-color: #fff;
  padding-top: 90px;
}

.CustomTable_bodythemedark__4wTbd {
  background-color: #132337;
  padding-top: 90px;
}

.CustomTable_bodythemeNew__dP\\+RE {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.CustomTable_headerthemelight__cCPeB {
  background-color: #fff;
}

.CustomTable_headerthemedark__IdfB7 {
  background-color: #132337;
}

.CustomTable_top_header__WYT4x {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.CustomTable_menuthemelight__PlXna {
  background-color: #f5f6fa;
}

.CustomTable_menuthemedark__VXeSp {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.CustomTable_menulinklight__VU\\+eL span {
  color: #666666 !important;
}

.CustomTable_menulinklight__VU\\+eL a {
  color: #CBCBCB !important;
}

.CustomTable_menulinklight__VU\\+eL:hover span,
.CustomTable_menulinklight__VU\\+eL:hover a {
  color: #fff !important;
}

.CustomTable_menulinkdarkSelected__uPgl6 {
  background-color: #1c2e45;
  color: #3b82f6;
}

.CustomTable_menuthemelight__PlXna .CustomTable_menulinklightSelected__lbhlE {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.CustomTable_menulinkdark__AEPh4 {
  color: #92afd3 !important;
}

.CustomTable_menulinklight__VU\\+eL:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.CustomTable_menulinklight__VU\\+eL .CustomTable_sub_arrow__h31Ag svg path {
  stroke: #CBCBCB !important;
}

.CustomTable_menulinklight__VU\\+eL:hover .CustomTable_sub_arrow__h31Ag svg path {
  stroke: #fff !important;
}

.CustomTable_menulinkdark__AEPh4 .CustomTable_sub_arrow__h31Ag svg path {
  stroke: #92afd3 !important;
}

.CustomTable_menulinkdark__AEPh4:hover .CustomTable_sub_arrow__h31Ag svg path {
  stroke: #fff !important;
}

.CustomTable_menulinklight__VU\\+eL:hover svg path,
.CustomTable_menulinklightSelected__lbhlE svg path {
  fill: #fff !important;
}

.CustomTable_menulinkdark__AEPh4:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.CustomTable_headinglight__QM9uu {
  color: #60677e;
}

.CustomTable_headingdark__3uUk4 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.CustomTable_searchboxlight__zuKty {
  background-color: #fff;
  border: none;
}

.CustomTable_searchboxdark__PxnqP {
  background-color: #132337;
  color: #fff;
  border: none;
}

.CustomTable_searchboxdark__PxnqP::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.CustomTable_tableheadlight__IdC3o {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.CustomTable_tableheadlight__IdC3o th {
  color: #fff;
}

thead .CustomTable_tableheadlight__IdC3o th:first-child,
thead .CustomTable_tableheaddark__g7FzQ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .CustomTable_tableheadlight__IdC3o th:last-child,
thead .CustomTable_tableheaddark__g7FzQ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.CustomTable_table__iy2D6.CustomTable_table-borderless__uLu3W {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.CustomTable_tableheaddark__g7FzQ {
  background-color: #132337;
  color: #fff;
}

.CustomTable_table-borderless__uLu3W tr:nth-child(even) {
  background-color: #F9FAFB;
}

.CustomTable_table-borderless__uLu3W .CustomTable_left-section__mVAsW {
  padding-top: 10px;
}

.CustomTable_tablebodylight__02org td,
.CustomTable_tablebodydark__dThyA td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.CustomTable_tablebodylight__02org {
  background-color: #fff;
}
.CustomTable_tablebodylight__02org:hover {
  background-color: #fff;
  cursor: auto;
}
.CustomTable_tablebodylight__02org p {
  line-height: 24px;
}

.CustomTable_tablebodydark__dThyA {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.CustomTable_tablebodydark__dThyA:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.CustomTable_paginationlight__LnejK {
  color: #60677e !important;
  font-size: 13px !important;
}

.CustomTable_paginationdark__YF7sC {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.CustomTable_formthemelight__rgUHq {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.CustomTable_formthemedark__TVLs0 {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.CustomTable_formthemedark__TVLs0 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.CustomTable_viewformlight__12lQy {
  background-color: #f3f6f9;
}

.CustomTable_permissionboxlight__jF5mU {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.CustomTable_permissionboxdark__0Q3M3 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.CustomTable_errormsgclr__HgYbU {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.CustomTable_graphclrlight__h6xoM {
  background-color: #fff;
}

.CustomTable_graphclrdark__Mizlb {
  background-color: #132337;
}

/* 
Counter theme
*/
#CustomTable_card1bglight__iVNhH {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#CustomTable_card1bgdark__ZF-ZD {
  background: #392f28;
}

#CustomTable_card2bglight__JhQdY {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#CustomTable_card2bgdark__6WBFj {
  background: #1c3238;
}

#CustomTable_card3bglight__Jv4fI {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#CustomTable_card3bgdark__d43QY {
  background: #3a2434;
}

#CustomTable_card4bglight__tEg-v {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#CustomTable_card4bgdark__FmvZq {
  background: #2f264f;
}

#CustomTable_card1bgdark__ZF-ZD a,
#CustomTable_card1bgdark__ZF-ZD p,
#CustomTable_card2bgdark__6WBFj a,
#CustomTable_card2bgdark__6WBFj p,
#CustomTable_card3bgdark__d43QY a,
#CustomTable_card3bgdark__d43QY p,
#CustomTable_card4bgdark__FmvZq a,
#CustomTable_card4bgdark__FmvZq p {
  color: #fff;
}

/* 
Action button theme
*/
.CustomTable_actionbtnlight__GUqS2 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.CustomTable_actionbtndark__\\+KkJQ {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.CustomTable_profiledropdownlight__1bU1g {
  background-color: #fff;
}

.CustomTable_profiledropdowndark__LY9-d {
  background-color: #151521;
}

.CustomTable_settingsection__JwBhC #CustomTable_addform__bsiqA.CustomTable_formthemedark__TVLs0 .CustomTable_savebtn__jNgkY {
  background-color: #3b82f6;
  color: #fff;
}

#CustomTable_addform__bsiqA.CustomTable_formthemedark__TVLs0 .CustomTable_savebtn__jNgkY {
  background-color: #3b82f6;
  color: #fff;
}

.CustomTable_profile_conatiner__KBa-D {
  border-radius: 5px !important;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_ag-theme-alpine__n4MO\\+ .CustomTable_ag-row__a9gWA {
  background: #000 !important;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_formbtn__O1heh {
  background-color: #3b82f6;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_formbtn__O1heh:hover {
  background-color: #2563eb;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_resetbtn__ZdcfW {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_resetbtn__ZdcfW:hover {
  background-color: #3b82f6;
}

.CustomTable_headingdark__3uUk4 span {
  background-color: #132337;
}

.CustomTable_resetbtn__ZdcfW {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.CustomTable_resetbtn__ZdcfW:hover,
.CustomTable_resetbtn__ZdcfW:active,
.CustomTable_resetbtn__ZdcfW:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.CustomTable_addBtn__uulum {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.CustomTable_addDltBtn__19JTR {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.CustomTable_addbtnlight__3kR\\+- {
  background-color: #38A169;
}

.CustomTable_addbtndark__Nv2XQ {
  background-color: #3b82f6;
}

.CustomTable_addbtndark__Nv2XQ:hover {
  background-color: #2563eb;
}

.CustomTable_formthemedark__TVLs0 label {
  color: #92afd3;
}

.CustomTable_addBtn__uulum svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.CustomTable_addBtn__uulum:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.CustomTable_cust_addBtn__z5GCF.CustomTable_addBtn__uulum svg {
  top: 2px;
}

.CustomTable_deleteBtn__8UKDC {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.CustomTable_deleteBtn__8UKDC {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.CustomTable_deleteBtn__8UKDC:active,
.CustomTable_deleteBtn__8UKDC:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.CustomTable_deleteBtn__8UKDC svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.CustomTable_deleteBtn__8UKDC:hover,
.CustomTable_deleteBtn__8UKDC:active,
.CustomTable_deleteBtn__8UKDC:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.CustomTable_confirmBtn__j6s5P {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.CustomTable_confirmBtn__j6s5P:hover,
.CustomTable_confirmBtn__j6s5P:active,
.CustomTable_confirmBtn__j6s5P:focus {
  background-color: #0f1824 !important;
}

.CustomTable_confirmBtn__j6s5P svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.CustomTable_delPopContainer__Yli4O .CustomTable_modal-body__nXHRv {
  padding: 35px;
  text-align: center;
}

.CustomTable_delPopContainer__Yli4O .CustomTable_delet_icon__pZBTF {
  margin-bottom: 11px;
}

.CustomTable_delPopContainer__Yli4O p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.CustomTable_arrowback__lEcV3 svg {
  fill: #000;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_arrowback__lEcV3 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_arrowback__lEcV3 svg {
  fill: #3b82f6;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_drpdwn_btn__-ICa6 {
  background-color: #132337;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_empname__Gud6A {
  color: #92afd3 !important;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_navitemli__Crp5Y a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_tabnavli__EDUVP a.CustomTable_settingsgeneral__7hQmm,
.CustomTable_bodythemedark__4wTbd .CustomTable_tabnavli__EDUVP a.CustomTable_settingslinks__m0-B\\+:hover {
  background-color: #3b82f6;
  color: #fff;
}

.CustomTable_bodythemedark__4wTbd .CustomTable_tabnavli__EDUVP a.CustomTable_settingslinks__m0-B\\+ {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.CustomTable_headerthemedark__IdfB7 .CustomTable_dropdown_menu_contain__GquRL {
  background-color: #1c2e45;
  color: #fff;
}

.CustomTable_headerthemedark__IdfB7 .CustomTable_dropdown_menu_contain__GquRL ul li a,
.CustomTable_headerthemedark__IdfB7 .CustomTable_dropdown_menu_contain__GquRL .CustomTable_dropdown_item__M5hwN,
.CustomTable_headerthemedark__IdfB7 .CustomTable_dropdown_menu_contain__GquRL .CustomTable_dropdown_item__M5hwN h5 {
  color: #fff;
}

.CustomTable_headerthemedark__IdfB7 .CustomTable_dropdown_menu_contain__GquRL ul li a:hover,
.CustomTable_headerthemedark__IdfB7 .CustomTable_dropdown_menu_contain__GquRL .CustomTable_dropdown_item__M5hwN:hover {
  background-color: #132337;
  color: #fff;
}

.CustomTable_dropdown_item__M5hwN:active {
  background-color: #F5F6FA;
}

.CustomTable_profile_arrrow_dwn__w4lhT {
  stroke: #132337;
}

.CustomTable_headerthemedark__IdfB7 .CustomTable_profile_arrrow_dwn__w4lhT {
  stroke: #fff;
}

.CustomTable_dateinputbox1__hE-gs input,
.CustomTable_dateinputbox1__hE-gs span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.CustomTable_delPopContainer__Yli4O .CustomTable_modal-content__KLD-D {
  border-radius: 10px;
  min-width: 399px;
}

.CustomTable_larg_model__\\+y4\\+F .CustomTable_modal-dialog__nITLt {
  max-width: 100% !important;
}

.CustomTable_larg_model__\\+y4\\+F .CustomTable_modal-content__KLD-D {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.CustomTable_larg_model__\\+y4\\+F .CustomTable_modal-header__Nrzfp {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .CustomTable_btn-primary__neaPh:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.CustomTable_form-select__tehR- {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .CustomTable_CustomTable_tableheadlight__HuHZw__BGQyU th:first-child,
thead .CustomTable_CustomTable_tableheaddark__nwqb4__ZBQQ2 th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .CustomTable_tableheadlight__IdC3o th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .CustomTable_dashboard__t39AK {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .CustomTable_cont2__lnfXt {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .CustomTable_sectionright__9r24f {
    float: unset !important;
  }
  .CustomTable_dashboard__t39AK {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .CustomTable_cont2__lnfXt {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .CustomTable_bodythemelight__3QZuf,
.CustomTable_bodythemedark__4wTbd {
    padding-top: 110px;
  }
  .CustomTable_delPopContainer__Yli4O .CustomTable_modal-content__KLD-D {
    min-width: 100%;
  }
  .CustomTable_delPopContainer__Yli4O .CustomTable_modal-body__nXHRv {
    padding: 15px;
  }
  .CustomTable_larg_model__\\+y4\\+F .CustomTable_modal-content__KLD-D {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .CustomTable_exer_modal_contain__1XkUu .CustomTable_modal-dialog__nITLt {
    max-width: 1055px;
  }
  .CustomTable_delPopContainer__Yli4O .CustomTable_modal-dialog__nITLt {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.CustomTable_active_show_outer__jfLnT h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .CustomTable_active_show_outer__jfLnT h2 {
    margin-top: 15px;
  }
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn {
  width: 100%;
  display: block;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_img__THmPG {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_img__THmPG {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_img__THmPG img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde {
  width: 100%;
  display: block;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde svg {
  flex-shrink: 0;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde .CustomTable_act_box_bdg__sBuaN {
  width: 100%;
  margin-bottom: 12px;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde .CustomTable_act_box_bdg__sBuaN span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde .CustomTable_act_box_bdg__sBuaN .CustomTable_sold__SN-4Y {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.CustomTable_active_show_outer__jfLnT .CustomTable_active_show_inner__yRDXn .CustomTable_act_box_cnt__FXzde p .CustomTable_timezone_code_pill__Oy5i5 {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#CustomTable_attent_details_row1__rQ2Co {
  margin-bottom: 0 !important;
}

.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_l__XJXww img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n {
  flex: 1 1;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS .CustomTable_attent_details_row_box__JwSJc {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS .CustomTable_attent_details_row_box__JwSJc {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS .CustomTable_attent_details_row_box__JwSJc {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS .CustomTable_attent_details_row_box__JwSJc p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row__DQbwS .CustomTable_attent_details_row_box__JwSJc h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row_last__GmPIs {
  margin-bottom: 0px !important;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row_last__GmPIs.CustomTable_interesting_fact__rwgUI {
  padding-top: 30px;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row_last__GmPIs.CustomTable_interesting_fact__rwgUI .CustomTable_attent_details_row_box__JwSJc {
  width: 100%;
}
.CustomTable_attent_details__Bkbsm .CustomTable_attent_details_inner__\\+\\+10h .CustomTable_attent_details_inner_r__w3Y-n .CustomTable_attent_details_row_last__GmPIs.CustomTable_interesting_fact__rwgUI .CustomTable_attent_details_row_box__JwSJc h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.CustomTable_showbox_sec__OjXBl {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .CustomTable_showbox_sec__OjXBl {
    justify-content: center;
  }
}

.CustomTable_show_box_main__vGbYK {
  margin: 10px 0px;
}
.CustomTable_show_box_main__vGbYK .CustomTable_show_box__PFrRX {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .CustomTable_show_box_main__vGbYK .CustomTable_show_box__PFrRX {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .CustomTable_show_box_main__vGbYK .CustomTable_show_box__PFrRX {
    min-height: 500px;
    width: 200px !important;
  }
}
.CustomTable_show_box_main__vGbYK .CustomTable_show_box__PFrRX img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .CustomTable_show_box_main__vGbYK .CustomTable_show_box__PFrRX img {
    max-height: 300px !important;
  }
}
.CustomTable_show_box_main__vGbYK .CustomTable_show_box__PFrRX:last-child {
  margin-right: 0px !important;
}
.CustomTable_show_box_main__vGbYK .CustomTable_no_show_box__rACIP {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .CustomTable_show_box_main__vGbYK .CustomTable_no_show_box__rACIP {
    width: 250px !important;
  }
}
.CustomTable_show_box_main__vGbYK .CustomTable_no_show_box__rACIP img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .CustomTable_show_box_main__vGbYK .CustomTable_no_show_box__rACIP img {
    max-height: 350px !important;
  }
}
.CustomTable_show_box_main__vGbYK .CustomTable_no_show_box__rACIP h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .CustomTable_show_box_main__vGbYK .CustomTable_no_show_box__rACIP h6 {
    font-size: 20px;
  }
}

.CustomTable_attent_flex__s\\+VTJ {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.CustomTable_attent_flex__s\\+VTJ h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

#CustomTable_container__pIzne {
  padding: 0px;
}

#CustomTable_tableheading__WkGW4 {
  font-size: 16px;
  margin-top: 20px;
}

.CustomTable_search_box__tpqTj {
  position: relative;
}

#CustomTable_spinner__RUGkE {
  float: right;
  margin-top: -25px;
  position: relative;
  z-index: 1;
  margin-right: 10px;
  cursor: pointer;
  color: #131F43;
}

.CustomTable_form_wrapper__3BH58 {
  display: block;
}
.CustomTable_form_wrapper__3BH58:nth-child(3) {
  order: 3;
}

@media screen and (max-width: 998px) {
  .CustomTable_search_contain__kT0Lp::after {
    top: 14px;
  }
}

@media screen and (max-width: 998px) {
  .CustomTable_search_btn__uBDFt {
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }
}

.CustomTable_tablebtn__QMTv7 {
  width: 70px;
  padding: 6px;
  border: none;
  background-color: #131F43;
  border-radius: 5px;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}
.CustomTable_tablebtn__QMTv7:hover {
  background-color: rgba(37, 105, 109, 0.864);
}

.CustomTable_activeEventCard__K2nP6 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: #f9f9f9;
  border-radius: 8px;
  width: 550px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
  margin-top: 20px;
}

.CustomTable_eventImage__JRA3W {
  width: 510px;
  height: 250px;
  object-fit: cover;
  margin: 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
@media screen and (max-width: 768px) {
  .CustomTable_eventImage__JRA3W {
    width: 100% !important;
    object-fit: contain;
  }
}

.CustomTable_eventDetails__pUARd {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.CustomTable_eventTitle__AUsxh {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.CustomTable_eventDescription__UiyRw {
  font-size: 16px;
  color: #555;
  margin-top: 5px;
}

.CustomTable_tokentransfersty__UcVrc {
  color: var(--Font-black, #0B0D0F);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 30px;
}
@media screen and (max-width: 768px) {
  .CustomTable_tokentransfersty__UcVrc {
    margin-top: 15px;
  }
}

.CustomTable_historystyin__1OGro {
  color: var(--Font-black, #0B0D0F);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 30px;
}
@media screen and (max-width: 768px) {
  .CustomTable_historystyin__1OGro {
    margin-bottom: 0 !important;
  }
}

.CustomTable_tokentransferstyin__M0YpN {
  color: var(--Font-black, #0B0D0F);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 25px;
  border-bottom: 1px dashed #D4D9EE !important;
  padding-bottom: 25px;
}
@media screen and (max-width: 768px) {
  .CustomTable_tokentransferstyin__M0YpN {
    padding-bottom: 15px;
  }
}

.CustomTable_searchwrapsec__dqzXn {
  margin-top: 50px;
}
@media screen and (max-width: 768px) {
  .CustomTable_searchwrapsec__dqzXn {
    margin-top: 15px;
  }
}

table {
  border-collapse: separate !important;
  border-spacing: 0 6px !important;
  width: 100% !important;
}

.CustomTable_dropdown__Acqot {
  position: relative;
  margin-top: 10px;
  width: 100%;
  z-index: 9999;
}

.CustomTable_dropdownContent__y9U\\+a {
  background-color: #ffffff;
  padding: 12px 16px;
  border: none;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 20px 0;
}

td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}

td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

.CustomTable_tableheaddiv__1f\\+0p {
  display: flex;
}

th, td {
  font-size: 15px;
}

th {
  padding: 0.8rem 1rem !important;
}

td {
  padding: 0.5rem 1rem !important;
  line-height: 28px;
}

.CustomTable_sortbtn__0Af18 {
  border: none;
  background: none;
  color: #6E6E6E;
}

.CustomTable_order_date__WQjua {
  margin-top: 5px;
  font-size: 12px;
  color: #000;
  font-weight: normal;
}

h6 {
  color: #000;
}

.CustomTable_norecord__Wrjmd {
  font-size: 22px;
  margin-top: 10px;
  color: #939090;
}

.CustomTable_norecordsdiv__51CZC {
  position: absolute;
  left: 42%;
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.CustomTable_sectionright__9r24f {
  float: right;
  display: flex;
}
.CustomTable_sectionright__9r24f #CustomTable_dropdown__Acqot {
  margin: 0px 10px 10px 10px;
}
.CustomTable_sectionright__9r24f #CustomTable_dropdown__Acqot button {
  background-color: #131F43;
  border-radius: 5px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  min-width: 140px;
  min-height: 44px;
}
.CustomTable_sectionright__9r24f a {
  font-size: 14px;
}
.CustomTable_sectionright__9r24f #CustomTable_del_icon__\\+sFAJ {
  font-size: 12px;
  margin-left: 5px;
}

@media only screen and (max-width: 600px) {
  #CustomTable_dashboardcont2__OqvNq {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}
tr:nth-child(even) {
  background-color: #fcfcfc;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/TokenTransferTable/CustomTable.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AAzlCA;EACE,YAAA;AA4lCF;;AAzlCA;EACI,eAAA;EACA,gBAAA;AA4lCJ;;AAzlCA;EACE,kBAAA;AA4lCF;;AAxlCA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cD6CiB;AC8iCnB;;AAxlCA;EACE,cAAA;AA2lCF;AA1lCE;EACE,QAAA;AA4lCJ;;AAtlCE;EACE;IACE,SAAA;EAylCJ;AACF;;AAplCE;EADF;IAEI,0BAAA;IACA,8BAAA;EAwlCF;AACF;;AAplCA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBDce;ECbf,kBAAA;EACA,WDDU;ECEV,gBAAA;EACA,mBAAA;EACA,eAAA;AAulCJ;AArlCI;EACE,2CDOe;ACglCrB;;AAnlCE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AAslCJ;;AAnlCE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;AAslCJ;AArlCI;EAPF;IAQI,sBAAA;IACA,mBAAA;EAwlCJ;AACF;;AArlCE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAwlCJ;;AArlCE;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAwlCJ;;AArlCE;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAwlCJ;;AAtlCE;EACE,iCAAA;EACJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAylCA;AAxlCA;EAPE;IAQA,gBAAA;EA2lCA;AACF;;AAzlCE;EACE,iCAAA;EACJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA4lCA;AA3lCA;EAPE;IAQA,2BAAA;EA8lCA;AACF;;AA5lCE;EACE,iCAAA;EACJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oBAAA;AA+lCA;AA9lCA;EATE;IAUA,oBAAA;EAimCA;AACF;;AA9lCE;EACE,gBAAA;AAimCJ;AAhmCI;EAFF;IAGE,gBAAA;EAmmCF;AACF;;AA/lCA;EACI,oCAAA;EACA,gCAAA;EACA,sBAAA;AAkmCJ;;AAhmCA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AAmmCF;;AAhmCA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,+CAAA;EACA,kBAAA;EACA,cAAA;AAmmCF;;AA7lCA;;EAEI,0BAAA;AAgmCJ;;AA5lCA;;EAEI,0BAAA;AA+lCJ;;AA5lCA;EACE,aAAA;AA+lCF;;AA7lCE;EACE,eAAA;AAgmCJ;;AA3lCE;EACE,+BAAA;AA8lCJ;;AA1lCE;EACE,+BAAA;EACA,iBAAA;AA6lCJ;;AAjlCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;AAolCF;;AAjlCA;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAolCJ;;AAjlCA;EACE,WAAA;AAolCF;;AAhlCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAmlCJ;;AAjlCE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAolCJ;;AA/kCA;EACE,YAAA;EACA,aAAA;AAklCF;AAhlCE;EACE,0BAAA;AAklCJ;AAhlCE;EACI,yBD/La;ECgMb,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAklCN;AAhlCE;EACI,eAAA;AAklCN;AA/kCE;EACE,eAAA;EACA,gBAAA;AAilCJ;;AA3kCA;EACE;IACI,wBDpMM;ICqMN,UDpMK;ICqML,kBAAA;IACA,aD5Ma;EC0xCjB;AACF;AA5kCC;EACC,yBAAA;AA8kCF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n\n#container{\n  padding: 0px;\n}\n\n#tableheading{\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n.search_box{\n  position: relative;\n}\n \n\n#spinner{\n  float: right;\n  margin-top: -25px;\n  position: relative;\n  z-index: 1;\n  margin-right: 10px;\n  cursor: pointer;\n  color: $primary-btncolor;\n}\n\n.form_wrapper {\n  display: block;\n  &:nth-child(3) {\n    order: 3;\n  }\n}\n\n\n.search_contain {\n  @media screen and (max-width: 998px) {\n    &::after {\n      top: 14px;\n    }\n  }\n}\n\n.search_btn {\n  @media screen and (max-width: 998px) {\n    margin-top: 0px !important;\n    margin-bottom: 20px !important;\n  }\n}\n\n\n.tablebtn{\n    width: 70px;\n    padding: 6px;\n    border:  none;\n    background-color: $primary-btncolor;\n    border-radius: 5px;\n    color: $white-color;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 14px;\n\n    &:hover{\n      background-color: $secondary-btncolor;\n    }\n  }\n\n  .activeEventCard {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    width: 550px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-bottom: 50px;\n    margin-top: 20px;\n  }\n  \n  .eventImage {\n    width: 510px;\n    height: 250px;\n    object-fit: cover;\n    margin: 20px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    @media screen and (max-width:768px) {\n      width: 100% !important;\n      object-fit: contain;\n    }\n  }\n  \n  .eventDetails {\n    padding: 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .eventTitle {\n    font-size: 18px;\n    font-weight: bold;\n    margin: 0;\n    color: #333;\n  }\n  \n  .eventDescription {\n    font-size: 16px;\n    color: #555;\n    margin-top: 5px;\n  }\n  .tokentransfersty{\n    color: var(--Font-black, #0B0D0F);\nfont-size: 22px;\nfont-style: normal;\nfont-weight: 700;\nline-height: normal;\nmargin-bottom: 30px;\n@media screen and (max-width:768px) {\n  margin-top: 15px;\n}\n  } \n  .historystyin{\n    color: var(--Font-black, #0B0D0F);\nfont-size: 22px;\nfont-style: normal;\nfont-weight: 700;\nline-height: normal;\nmargin-bottom: 30px;\n@media screen and (max-width:768px) {\n  margin-bottom: 0 !important;\n}\n  } \n  .tokentransferstyin{\n    color: var(--Font-black, #0B0D0F);\nfont-size: 22px;\nfont-style: normal;\nfont-weight: 700;\nline-height: normal;\nmargin-bottom: 25px;\nborder-bottom: 1px dashed #D4D9EE !important;\npadding-bottom: 25px;\n@media screen and (max-width:768px) {\n  padding-bottom: 15px;\n}\n\n  } \n  .searchwrapsec{\n    margin-top: 50px;\n    @media screen and (max-width:768px) {\n    margin-top: 15px;\n  \n    }\n  }\n\ntable{\n    border-collapse:separate !important;\n    border-spacing:0 6px !important;\n    width: 100% !important;\n  }\n.dropdown {\n  position: relative;\n  margin-top: 10px;\n  width: 100%;\n  z-index: 9999;\n}\n\n.dropdownContent {\n  background-color: #ffffff;\n  padding: 12px 16px;\n  border: none;\n  box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 10%);\n  border-radius: 5px;\n  margin: 20px 0;\n}\n\n  \n\n// Set border-radius on the top-left and bottom-left of the first table data on the table row\ntd:first-child,\nth:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n\n// Set border-radius on the top-right and bottom-right of the last table data on the table row\ntd:last-child,\nth:last-child {\n    border-radius: 0 8px 8px 0;\n  }\n  \n.tableheaddiv{\n  display: flex;\n}\n  th,td{\n    font-size: 15px;\n     \n     \n  }\n\n  th{\n    padding: 0.8rem 1rem !important;\n\n  }\n\n  td{\n    padding: .5rem 1rem !important;\n    line-height: 28px;\n  }\n\n\n\n// .order_date{\n//     margin-top: 5px;\n//     font-size: 12px;\n//     color: #898989;\n//     font-weight: normal;\n//   }\n\n.sortbtn{\n  border: none;\n  background: none;\n  color: #6E6E6E;\n  }\n\n.order_date{\n    margin-top: 5px;\n    font-size: 12px;\n    color:#000;\n    font-weight: normal;\n  }\n\nh6{\n  color: #000;\n  }\n\n  \n  .norecord {\n    font-size: 22px;\n    margin-top: 10px;\n    color: #939090;\n  }\n  .norecordsdiv{\n    position: absolute;\n    left: 42%;\n    margin-top: 2%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n\n\n.sectionright{\n  float: right;\n  display: flex;\n\n  #dropdown{\n    margin:0px 10px 10px 10px;\n  }\n  #dropdown button{\n      background-color:$primary-btncolor;\n      border-radius:5px;\n      border:none;\n      box-shadow:none;\n      font-size:14px;\n      min-width: 140px;\n      min-height: 44px;\n  }\n  a{\n      font-size:14px;\n       \n  }\n  #del_icon{\n    font-size: 12px;\n    margin-left:5px;\n}\n\n}\n\n\n@media only screen and (max-width: 600px) {\n  #dashboardcont2{\n      width: $dashwidth;\n      left: $dashleft;\n      position: relative;\n      padding: $dashboardpadding;\n  }\n}\n tr:nth-child(even){\n  background-color: #fcfcfc;\n} \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `CustomTable_dashboard__t39AK`,
	"dashboardContain": `CustomTable_dashboardContain__VKEgM`,
	"bodythemedark": `CustomTable_bodythemedark__4wTbd`,
	"cont2": `CustomTable_cont2__lnfXt`,
	"top_header": `CustomTable_top_header__WYT4x`,
	"top_header_inner": `CustomTable_top_header_inner__9fMtV`,
	"subLink": `CustomTable_subLink__8x57G`,
	"cst_vendr": `CustomTable_cst_vendr__JonZi`,
	"form-control": `CustomTable_form-control__xBV9j`,
	"footer": `CustomTable_footer__6d2-Q`,
	"bodythemelight": `CustomTable_bodythemelight__3QZuf`,
	"bodythemeNew": `CustomTable_bodythemeNew__dP+RE`,
	"headerthemelight": `CustomTable_headerthemelight__cCPeB`,
	"headerthemedark": `CustomTable_headerthemedark__IdfB7`,
	"menuthemelight": `CustomTable_menuthemelight__PlXna`,
	"menuthemedark": `CustomTable_menuthemedark__VXeSp`,
	"menulinklight": `CustomTable_menulinklight__VU+eL`,
	"menulinkdarkSelected": `CustomTable_menulinkdarkSelected__uPgl6`,
	"menulinklightSelected": `CustomTable_menulinklightSelected__lbhlE`,
	"menulinkdark": `CustomTable_menulinkdark__AEPh4`,
	"sub_arrow": `CustomTable_sub_arrow__h31Ag`,
	"headinglight": `CustomTable_headinglight__QM9uu`,
	"headingdark": `CustomTable_headingdark__3uUk4`,
	"searchboxlight": `CustomTable_searchboxlight__zuKty`,
	"searchboxdark": `CustomTable_searchboxdark__PxnqP`,
	"tableheadlight": `CustomTable_tableheadlight__IdC3o`,
	"tableheaddark": `CustomTable_tableheaddark__g7FzQ`,
	"table": `CustomTable_table__iy2D6`,
	"table-borderless": `CustomTable_table-borderless__uLu3W`,
	"left-section": `CustomTable_left-section__mVAsW`,
	"tablebodylight": `CustomTable_tablebodylight__02org`,
	"tablebodydark": `CustomTable_tablebodydark__dThyA`,
	"paginationlight": `CustomTable_paginationlight__LnejK`,
	"paginationdark": `CustomTable_paginationdark__YF7sC`,
	"formthemelight": `CustomTable_formthemelight__rgUHq`,
	"formthemedark": `CustomTable_formthemedark__TVLs0`,
	"viewformlight": `CustomTable_viewformlight__12lQy`,
	"permissionboxlight": `CustomTable_permissionboxlight__jF5mU`,
	"permissionboxdark": `CustomTable_permissionboxdark__0Q3M3`,
	"errormsgclr": `CustomTable_errormsgclr__HgYbU`,
	"graphclrlight": `CustomTable_graphclrlight__h6xoM`,
	"graphclrdark": `CustomTable_graphclrdark__Mizlb`,
	"card1bglight": `CustomTable_card1bglight__iVNhH`,
	"card1bgdark": `CustomTable_card1bgdark__ZF-ZD`,
	"card2bglight": `CustomTable_card2bglight__JhQdY`,
	"card2bgdark": `CustomTable_card2bgdark__6WBFj`,
	"card3bglight": `CustomTable_card3bglight__Jv4fI`,
	"card3bgdark": `CustomTable_card3bgdark__d43QY`,
	"card4bglight": `CustomTable_card4bglight__tEg-v`,
	"card4bgdark": `CustomTable_card4bgdark__FmvZq`,
	"actionbtnlight": `CustomTable_actionbtnlight__GUqS2`,
	"actionbtndark": `CustomTable_actionbtndark__+KkJQ`,
	"profiledropdownlight": `CustomTable_profiledropdownlight__1bU1g`,
	"profiledropdowndark": `CustomTable_profiledropdowndark__LY9-d`,
	"settingsection": `CustomTable_settingsection__JwBhC`,
	"addform": `CustomTable_addform__bsiqA`,
	"savebtn": `CustomTable_savebtn__jNgkY`,
	"profile_conatiner": `CustomTable_profile_conatiner__KBa-D`,
	"ag-theme-alpine": `CustomTable_ag-theme-alpine__n4MO+`,
	"ag-row": `CustomTable_ag-row__a9gWA`,
	"formbtn": `CustomTable_formbtn__O1heh`,
	"resetbtn": `CustomTable_resetbtn__ZdcfW`,
	"addBtn": `CustomTable_addBtn__uulum`,
	"addDltBtn": `CustomTable_addDltBtn__19JTR`,
	"addbtnlight": `CustomTable_addbtnlight__3kR+-`,
	"addbtndark": `CustomTable_addbtndark__Nv2XQ`,
	"cust_addBtn": `CustomTable_cust_addBtn__z5GCF`,
	"deleteBtn": `CustomTable_deleteBtn__8UKDC`,
	"confirmBtn": `CustomTable_confirmBtn__j6s5P`,
	"delPopContainer": `CustomTable_delPopContainer__Yli4O`,
	"modal-body": `CustomTable_modal-body__nXHRv`,
	"delet_icon": `CustomTable_delet_icon__pZBTF`,
	"arrowback": `CustomTable_arrowback__lEcV3`,
	"drpdwn_btn": `CustomTable_drpdwn_btn__-ICa6`,
	"empname": `CustomTable_empname__Gud6A`,
	"navitemli": `CustomTable_navitemli__Crp5Y`,
	"tabnavli": `CustomTable_tabnavli__EDUVP`,
	"settingsgeneral": `CustomTable_settingsgeneral__7hQmm`,
	"settingslinks": `CustomTable_settingslinks__m0-B+`,
	"dropdown_menu_contain": `CustomTable_dropdown_menu_contain__GquRL`,
	"dropdown_item": `CustomTable_dropdown_item__M5hwN`,
	"profile_arrrow_dwn": `CustomTable_profile_arrrow_dwn__w4lhT`,
	"dateinputbox1": `CustomTable_dateinputbox1__hE-gs`,
	"modal-content": `CustomTable_modal-content__KLD-D`,
	"larg_model": `CustomTable_larg_model__+y4+F`,
	"modal-dialog": `CustomTable_modal-dialog__nITLt`,
	"modal-header": `CustomTable_modal-header__Nrzfp`,
	"btn-primary": `CustomTable_btn-primary__neaPh`,
	"form-select": `CustomTable_form-select__tehR-`,
	"CustomTable_tableheadlight__HuHZw": `CustomTable_CustomTable_tableheadlight__HuHZw__BGQyU`,
	"CustomTable_tableheaddark__nwqb4": `CustomTable_CustomTable_tableheaddark__nwqb4__ZBQQ2`,
	"sectionright": `CustomTable_sectionright__9r24f`,
	"exer_modal_contain": `CustomTable_exer_modal_contain__1XkUu`,
	"active_show_outer": `CustomTable_active_show_outer__jfLnT`,
	"active_show_inner": `CustomTable_active_show_inner__yRDXn`,
	"act_box_img": `CustomTable_act_box_img__THmPG`,
	"act_box_cnt": `CustomTable_act_box_cnt__FXzde`,
	"act_box_bdg": `CustomTable_act_box_bdg__sBuaN`,
	"sold": `CustomTable_sold__SN-4Y`,
	"timezone_code_pill": `CustomTable_timezone_code_pill__Oy5i5`,
	"attent_details_row1": `CustomTable_attent_details_row1__rQ2Co`,
	"attent_details": `CustomTable_attent_details__Bkbsm`,
	"attent_details_inner": `CustomTable_attent_details_inner__++10h`,
	"attent_details_inner_l": `CustomTable_attent_details_inner_l__XJXww`,
	"attent_details_inner_r": `CustomTable_attent_details_inner_r__w3Y-n`,
	"attent_details_row": `CustomTable_attent_details_row__DQbwS`,
	"attent_details_row_box": `CustomTable_attent_details_row_box__JwSJc`,
	"attent_details_row_last": `CustomTable_attent_details_row_last__GmPIs`,
	"interesting_fact": `CustomTable_interesting_fact__rwgUI`,
	"showbox_sec": `CustomTable_showbox_sec__OjXBl`,
	"show_box_main": `CustomTable_show_box_main__vGbYK`,
	"show_box": `CustomTable_show_box__PFrRX`,
	"no_show_box": `CustomTable_no_show_box__rACIP`,
	"attent_flex": `CustomTable_attent_flex__s+VTJ`,
	"container": `CustomTable_container__pIzne`,
	"tableheading": `CustomTable_tableheading__WkGW4`,
	"search_box": `CustomTable_search_box__tpqTj`,
	"spinner": `CustomTable_spinner__RUGkE`,
	"form_wrapper": `CustomTable_form_wrapper__3BH58`,
	"search_contain": `CustomTable_search_contain__kT0Lp`,
	"search_btn": `CustomTable_search_btn__uBDFt`,
	"tablebtn": `CustomTable_tablebtn__QMTv7`,
	"activeEventCard": `CustomTable_activeEventCard__K2nP6`,
	"eventImage": `CustomTable_eventImage__JRA3W`,
	"eventDetails": `CustomTable_eventDetails__pUARd`,
	"eventTitle": `CustomTable_eventTitle__AUsxh`,
	"eventDescription": `CustomTable_eventDescription__UiyRw`,
	"tokentransfersty": `CustomTable_tokentransfersty__UcVrc`,
	"historystyin": `CustomTable_historystyin__1OGro`,
	"tokentransferstyin": `CustomTable_tokentransferstyin__M0YpN`,
	"searchwrapsec": `CustomTable_searchwrapsec__dqzXn`,
	"dropdown": `CustomTable_dropdown__Acqot`,
	"dropdownContent": `CustomTable_dropdownContent__y9U+a`,
	"tableheaddiv": `CustomTable_tableheaddiv__1f+0p`,
	"sortbtn": `CustomTable_sortbtn__0Af18`,
	"order_date": `CustomTable_order_date__WQjua`,
	"norecord": `CustomTable_norecord__Wrjmd`,
	"norecordsdiv": `CustomTable_norecordsdiv__51CZC`,
	"del_icon": `CustomTable_del_icon__+sFAJ`,
	"dashboardcont2": `CustomTable_dashboardcont2__OqvNq`
};
export default ___CSS_LOADER_EXPORT___;
